<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/general/gen062.svg"
          class="me-2"
        />Auditoria
      </h3>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div
            v-if="!this.showFilter"
            class="d-flex align-items-center position-relative my-1"
          >
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarAuditoria"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar Auditoria"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              @click="this.$refs.table.exportarExcel()"
              type="button"
              class="btn btn-sm btn-light-primary"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
              </span>
              Exportar
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          sortLabel="id"
          order="desc"
          empty-table-text="Nenhuma auditoria encontrada"
          @showFilter="this.showFilter = $event"
        >
          <template v-slot:cell-id="{ row: auditoria }">
            {{ auditoria.id }}
          </template>
          <template v-slot:cell-UsuarioNome="{ row: auditoria }">
            {{ auditoria.Usuario ? auditoria.Usuario.nome : "" }}
          </template>
          <template v-slot:cell-data="{ row: auditoria }">
            {{ this.$utils.formatarDataHoraFusoHorario(auditoria.data) }}
          </template>
          <template v-slot:cell-nome_tabela="{ row: auditoria }">
            {{ auditoria.nome_tabela }}
          </template>
          <template v-slot:cell-chave_primaria="{ row: auditoria }">
            {{ auditoria.chave_primaria }}
          </template>
          <template v-slot:cell-tipo="{ row: auditoria }">
            <span
              :class="[auditoria.tipo ? this.getTipoColor(auditoria.tipo) : '']"
              >{{ auditoria.tipo }}</span
            >
          </template>
          <template v-slot:cell-detalhes="{ row: auditoria }">
            <button
              class="btn btn-sm btn-light btn-active-light-primary py-2 ps-2 pe-0"
              data-kt-menu-trigger="click"
              data-kt-menu-placement="bottom-end"
              data-kt-menu-flip="top-end"
              @click="this.exibirDetalhes(auditoria.id)"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/general/gen004.svg" />
              </span>
            </button>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <AuditoriaDetalhesModal
    v-if="exibirAuditoriaDetalhes"
    :auditoria="this.auditoria"
    @exibirModalAuditoriaDetalhes="modalAuditoriaDetalhes"
  ></AuditoriaDetalhesModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import AuditoriaDetalhesModal from "@/views/auditoria/AuditoriaDetalhesModal.vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {
    Datatable,
    AuditoriaDetalhesModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    modalAuditoriaDetalhes(exibir) {
      this.exibirAuditoriaDetalhes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_auditoria_detalhes",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_auditoria_detalhes");
          },
          /*close*/ () => {
            this.modalAuditoriaDetalhes(false);
          }
        );
      }
    },
    getTipoColor(tipo) {
      if (tipo.toUpperCase() === "CREATE") {
        return "badge badge-light-success text-success";
      } else if (tipo.toUpperCase() === "DELETE") {
        return "badge badge-light-danger text-danger";
      } else if (tipo.toUpperCase() === "UPDATE") {
        return "badge badge-light-info text-info";
      } else if (tipo.toUpperCase() === "NONE") {
        return "badge badge-light-primary text-primary";
      } else {
        return "badge badge-light-dark text-dark";
      }
    },
    async exibirDetalhes(id) {
      this.auditoria = {};
      try {
        var ret = await this.$store.dispatch(
          "auditoria/getAuditoriaOData",
          "?$filter=id eq " +
            id +
            "&$expand=Usuario&$select=id,id_usuario,tipo,nome_tabela,data,valores_antigos,valores_novos,colunas_afetadas,chave_primaria"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.auditoria = ret.value[0];

          this.modalAuditoriaDetalhes(true);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nome_tabela, '" +
          pesquisa +
          "') or contains(Usuario/nome, '" +
          pesquisa +
          "') or contains(chave_primaria, '" +
          pesquisa +
          "') or contains(tipo, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  async mounted() {
    setTimeout(() => {
      this.nextFocus("txtPesquisarAuditoria");
    }, 800);
  },
  data() {
    return {
      showFilter: false,
      auditoria: {},
      exibirAuditoriaDetalhes: false,
      tableHeader: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Usuário",
          key: "UsuarioNome",
          sortingField: "Usuario/nome",
          sortable: true,
        },
        {
          name: "Data",
          key: "data",
          sortable: true,
        },
        {
          name: "Módulo",
          key: "nome_tabela",
          sortable: true,
        },
        {
          name: "Chave",
          key: "chave_primaria",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: true,
        },
        {
          name: "Detalhes",
          key: "detalhes",
          sortable: false,
        },
      ],
      tableData: {
        store: "auditoria/getAuditoriaOData",
        selectOData:
          "?$select=id,id_usuario,tipo,nome_tabela,data,chave_primaria&$expand=Usuario($select=nome)",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
